import BaseChatPanel from 'components/Chat/BaseChatPanel';
import useStudentSubmissionChat from 'hooks/chat/useStudentSubmissionChat';
import { shouldShowChatSuggestions } from 'utils/chat';

const StudentSubmissionChatPanel = ({ currentSubmission, isOpen, onBack, onChatUpdated }) => {
    const {
        chat,
        fileKey,
        hasOlderMessages,
        isBootstrapping,
        isLoadingOlderMessages,
        loadOlderMessages,
        onAssistantMessageCreated,
        onUserMessageCreated,
        showSuggestions,
        suggestions,
        viewModel,
    } = useStudentSubmissionChat({
        currentSubmission,
        isOpen,
        onChatUpdated,
        shouldShowChatSuggestions,
    });

    return (
        <BaseChatPanel
            chat={chat}
            fileKey={fileKey}
            hasOlderMessages={hasOlderMessages}
            isBootstrapping={isBootstrapping}
            isLoadingOlderMessages={isLoadingOlderMessages}
            isOpen={isOpen}
            onAssistantMessageCreated={onAssistantMessageCreated}
            onBack={onBack}
            onLoadOlderMessages={loadOlderMessages}
            onUserMessageCreated={onUserMessageCreated}
            suggestions={suggestions}
            showSuggestions={showSuggestions}
            viewModel={viewModel}
        />
    );
};

export default StudentSubmissionChatPanel;
